<template>
  <Layout>
    <!-- <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Product register timeline</h4>

            <div class="hori-timeline">
              <carousel
                ref="carousel"
                class="events navs-carousel"
                id="timeline-carousel"
                :navigation-enabled="false"
                :pagination-enabled="false"
                :perPageCustom="[
                  [480, 2],
                  [768, 4],
                ]"
              >
                <slide>
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">12 September</div>
                        <h5 class="mb-4">Event #1</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          It will be as simple as occidental in fact it will be
                          Cambridge
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">06 October</div>
                        <h5 class="mb-4">Event #2</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          To an English person, it will seem like simplified
                          English existence.
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="item event-list active">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">Current</div>
                        <h5 class="mb-4">My jobs</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          For science, music, sport, etc, Europe uses the same
                          vocabulary.
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">Next</div>
                        <h5 class="mb-4">Shipment Detail</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          New common language will be more simple than existing.
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">Next</div>
                        <h5 class="mb-4">Other Setting</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          It will be as simple as occidental in fact it will be
                          Cambridge
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
                <slide>
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <div class="text-primary mb-1">Next</div>
                        <h5 class="mb-4">Finish</h5>
                      </div>
                      <div class="event-down-icon">
                        <i
                          class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"
                        ></i>
                      </div>

                      <div class="mt-3 px-3">
                        <p class="text-muted">
                          To an English person, it will seem like simplified
                          English existence.
                        </p>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div class="owl-nav">
                <button
                  type="button"
                  role="presentation"
                  class="owl-prev"
                  @click.prevent="prevSlide"
                >
                  <i class="mdi mdi-chevron-left"></i>
                </button>
                <button
                  type="button"
                  role="presentation"
                  class="owl-next"
                  @click.prevent="nextSlide"
                >
                  <i class="mdi mdi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-5">Product register work process</h4>
            <div class>
              <ul class="verti-timeline list-unstyled">
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-copy-alt h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <b-container class="bv-example-row">
                            <b-row>
                              <b-col>
                                <a
                                  href="javascript: void(0);"
                                  class="accordion-list collapsed"
                                  v-b-toggle.accordion-1
                                >
                                  Basic Information
                                </a>
                              </b-col>
                              <b-col cols="6">
                                <div
                                  class="btn-group mr-2 mb-2 mb-sm-0 pull-right"
                                >
                                  <button
                                    type="button"
                                    v-b-toggle.accordion-1-review
                                    class="btn btn-primary"
                                  >
                                    <i class="bx bx-bell bx-tada"></i>
                                    <span
                                      style="top: -1rem"
                                      class="badge badge-danger badge-pill"
                                      >{{
                                        $t("navbar.dropdown.notification.badge")
                                      }}</span
                                    >
                                  </button>
                                </div>
                              </b-col>
                              <b-col cols="2">
                                <b-badge variant="success">Approved</b-badge>
                                <a
                                  href="javascript: void(0);"
                                  class="pull-right accordion-list collapsed"
                                  v-b-toggle.accordion-1
                                >
                                  <i class="mdi mdi-minus accor-plus-icon"></i>
                                </a>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-card-header>
                        <b-collapse
                          id="accordion-1"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <div class="row">
                              <div class="col-xl-8">
                                <div class="card">
                                  <div class="card-body">
                                    <h4 class="card-title">
                                      Basic Information
                                    </h4>
                                    <p class="card-title-desc">
                                      Fill all information below
                                    </p>

                                    <form>
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div class="form-group">
                                            <label for="productname"
                                              >Product Name</label
                                            >
                                            <input
                                              id="productname"
                                              name="productname"
                                              type="text"
                                              class="form-control"
                                            />
                                          </div>
                                          <div class="form-group">
                                            <label for="manufacturername"
                                              >Manufacturer Name</label
                                            >
                                            <input
                                              id="manufacturername"
                                              name="manufacturername"
                                              type="text"
                                              class="form-control"
                                            />
                                          </div>
                                          <div class="form-group">
                                            <label for="manufacturerbrand"
                                              >Manufacturer Brand</label
                                            >
                                            <input
                                              id="manufacturerbrand"
                                              name="manufacturerbrand"
                                              type="text"
                                              class="form-control"
                                            />
                                          </div>
                                          <div class="form-group">
                                            <label for="price">Price</label>
                                            <input
                                              id="price"
                                              name="price"
                                              type="text"
                                              class="form-control"
                                            />
                                          </div>
                                        </div>

                                        <div class="col-sm-6">
                                          <div class="form-group">
                                            <label class="control-label"
                                              >Category</label
                                            >
                                          </div>
                                          <div class="form-group">
                                            <label class="control-label"
                                              >Features</label
                                            >
                                          </div>
                                          <div class="form-group">
                                            <label for="productdesc"
                                              >Product Description</label
                                            >
                                            <textarea
                                              id="productdesc"
                                              class="form-control"
                                              rows="5"
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>

                                      <button
                                        type="submit"
                                        class="btn btn-primary mr-1"
                                      >
                                        Save Changes
                                      </button>
                                      <button
                                        type="submit"
                                        class="btn btn-secondary"
                                      >
                                        Cancel
                                      </button>
                                    </form>
                                  </div>
                                </div>
                              </div>

                              <div class="col-xl-4">
                                <b-collapse
                                  id="accordion-1-review"
                                  accordion="my-accordion-1"
                                  role="tabpanel"
                                >
                                  <div class="card">
                                    <div
                                      class="card-body"
                                      style="background-color: #cfcfcf"
                                    >
                                      <h4 class="card-title mb-4">
                                        Approval Reviews
                                      </h4>

                                      <div class="mt-4">
                                        <div>
                                          <b-form-checkbox
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3"
                                            checked
                                            >Product Name</b-form-checkbox
                                          >

                                          <b-form-checkbox
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-3"
                                            checked
                                            >Manufacturer Name</b-form-checkbox
                                          >

                                          <b-form-checkbox
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                                            checked
                                            >Manufacturer Brand</b-form-checkbox
                                          >

                                          <b-form-checkbox
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-warning mb-3"
                                            checked
                                            >Price</b-form-checkbox
                                          >

                                          <b-form-checkbox
                                            value="accepted"
                                            unchecked-value="not_accepted"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-3"
                                            checked
                                            >Category</b-form-checkbox
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </b-collapse>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-package h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <a
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-2
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">
                                  Series / Model Detail
                                </div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div class="pull-right group-status-panal">
                                    <b-badge variant="success"
                                      >Approved</b-badge
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-2"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <b-form>
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list active">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle bx-fade-right"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-car h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header
                          style="background-color: #cebbff"
                          header-tag="header"
                          role="tab"
                        >
                          <a
                            style="background-color: #cebbff"
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-3
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">
                                  Product Detail
                                  
                                </div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div
                                    class="pull-right group-status-panal"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-3"
                          visible
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body style="background-color: rgb(238 231 255)">
                            <b-form >
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-package h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <a
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-4
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">Image Management</div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div
                                    class="pull-right group-status-panal"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-4"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <b-form>
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-package h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <a
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-5
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">Product Content</div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div
                                    class="pull-right group-status-panal"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-5"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <b-form>
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-package h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <a
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-6
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">Shipment Detail</div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div
                                    class="pull-right group-status-panal"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-6"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <b-form>
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="media">
                    <div class="mr-3">
                      <i class="bx bx-package h2 text-primary"></i>
                    </div>
                    <div class="media-body">
                      <b-card no-body class="custom-accordion shadow-none mb-3">
                        <b-card-header header-tag="header" role="tab">
                          <a
                            href="javascript: void(0);"
                            class="accordion-list collapsed"
                            v-b-toggle.accordion-7
                          >
                            <div class="container">
                              <div class="row">
                                <div class="col-md-6">Other Setting</div>
                                <div class="col-md-6">
                                  <span class="pull-right"
                                    ><i
                                      class="mdi mdi-minus accor-plus-icon"
                                    ></i>
                                  </span>
                                  <div class="pull-right group-status-panal">
                                    <b-badge variant="success"
                                      >Approved</b-badge
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </b-card-header>
                        <b-collapse
                          id="accordion-7"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <b-form>
                              <b-form-group
                                label="First name"
                                label-for="formrow-firstname-input"
                              >
                                <b-form-input
                                  id="formrow-firstname-input"
                                  type="text"
                                ></b-form-input>
                              </b-form-group>

                              <div class="row">
                                <div class="col-md-6">
                                  <b-form-group
                                    label="Email"
                                    label-for="formrow-email-input"
                                  >
                                    <b-form-input
                                      id="formrow-email-input"
                                      type="email"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <b-form-group
                                      label="Password"
                                      label-for="formrow-password-input"
                                    >
                                      <b-form-input
                                        id="formrow-password-input"
                                        type="email"
                                      ></b-form-input>
                                    </b-form-group>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputCity"
                                  >
                                    <b-form-input
                                      id="formrow-inputCity"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                                <div class="col-lg-4">
                                  <b-form-group
                                    id="input-group-1"
                                    label="State"
                                    label-for="formrow-inputState"
                                  >
                                    <b-form-select
                                      id="formrow-inputState"
                                      :options="['Choose...', '...']"
                                      type="text"
                                    ></b-form-select>
                                  </b-form-group>
                                </div>

                                <div class="col-lg-4">
                                  <b-form-group
                                    label="City"
                                    label-for="formrow-inputZip"
                                  >
                                    <b-form-input
                                      id="formrow-inputZip"
                                      type="text"
                                    ></b-form-input>
                                  </b-form-group>
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="formrow-customCheck"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="formrow-customCheck"
                                    >Check me out</label
                                  >
                                </div>
                              </div>
                              <div>
                                <b-button variant="primary">Submit</b-button>
                              </div>
                            </b-form>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 text-center">
        <router-link to="/test2" tag="button">
            Preview
        </router-link>
      </div>
    </div> -->
  </Layout>
</template>

<script>
// import { Carousel, Slide } from "vue-carousel";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Timeline component
 */
export default {
  page: {
    title: "Product register",
    meta: [{ name: "description", content: appConfig.description }],
  },
  // components: { Layout, PageHeader, Carousel, Slide },
  data() {
    return {
      title: "Product register",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Product register",
          active: true,
        },
      ],
    };
  },
  methods: {
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    chain() {
      Swal.mixin({
        input: "text",
        confirmButtonText: "Next &rarr;",
        showCancelButton: true,
        confirmButtonColor: "#556ee6",
        cancelButtonColor: "#74788d",
        progressSteps: ["1", "2", "3"],
      })
        .queue([
          {
            title: "Question 1",
            text: "Chaining swal2 modals is easy",
          },
          "Question 2",
          "Question 3",
        ])
        .then((result) => {
          if (result.value) {
            Swal.fire({
              title: "All done!",
              html:
                "Your answers: <pre><code>" +
                JSON.stringify(result.value) +
                "</code></pre>",
              confirmButtonText: "Lovely!",
            });
          }
        });
    },
  },
};
</script>
<style>
.pull-right {
  float: right !important;
}

.group-status-panal {
  margin-right: 1rem;
}

.noti-icon-workprocess .badge {
  position: absolute;
  top: -5px;
  left: 130px;
}
</style>
